import { useQuery } from '@tanstack/vue-query'

import { explorerApi } from '~/api/client'
import { generalDelayCheckKey } from '~/api/service/query-keys.const'

export const generalService = {
  /** @description
   * res === 'true' ? 정상 : 비정상
   * 여기에서는 딜레이되었는지 여부를 리턴
   */
  useGetDelayCheck: () => {
    const getDelayCheck = async () => {
      // 임시 공지 5/13
      return false
      // const res = await explorerApi.monitorController.rpcHealthChecker()
      // return res.ISAVAIL !== 'true'
    }
    return useQuery([ ...generalDelayCheckKey ], getDelayCheck)
  }
}